import { render } from "./WCotizaciones.vue?vue&type=template&id=3055c132&scoped=true"
import script from "./WCotizaciones.vue?vue&type=script&lang=js"
export * from "./WCotizaciones.vue?vue&type=script&lang=js"

import "./WCotizaciones.vue?vue&type=style&index=0&id=3055c132&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3055c132"]])

export default __exports__